export enum RouteEnums {
    HOME = 'home',
    LOGGED_OUT = 'loggedOut',
    UNAUTHORISED = 'unauthorised',
    ERROR = 'error',
    NOT_FOUND = 'notFound'
}
